/* By Evie — soft section reveals. Progressive enhancement: the page is
   fully visible unless this script runs and can set up the observer. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('bv-motion');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bv-inview');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function init() {
    document.querySelectorAll('main .shopify-section').forEach(function (section) {
      io.observe(section);
    });
    /* safety net: if anything prevents observation, reveal everything */
    setTimeout(function () {
      document.querySelectorAll('main .shopify-section:not(.bv-inview)').forEach(function (section) {
        var rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          section.classList.add('bv-inview');
        }
      });
    }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
